import * as Sentry from '@sentry/react';
import { muiLicense } from '@diligentcorp/atlas-mui-license';
import '@fontsource-variable/plus-jakarta-sans';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import { env } from './utils';

window.global ||= window;
muiLicense.apply();

if (env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: env.REACT_APP_SENTRY_DSN,
    enabled: env.REACT_APP_SENTRY_REPORTING.length > 0,
    integrations: (defaults) => [
      ...defaults,
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
        maskAllInputs: true,
      }),
      Sentry.consoleLoggingIntegration({
        levels: ['log', 'info', 'warn', 'error'],
      }),
    ],
    tracesSampleRate: 1.0,
    environment: env.REACT_APP_ENVIRONMENT_NAME,
    normalizeDepth: 10,
    debug: env.REACT_APP_SENTRY_DEBUG.length > 0,
    release: env.REACT_APP_RELEASE_VERSIONS,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }
      return event;
    },
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'redux.action') {
        if (breadcrumb.data) {
          delete breadcrumb.data;
        }
      }
      return breadcrumb;
    },
    enableLogs: true,
  });
}

const container = document.getElementById('example');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(<App />);
